import React from 'react';
import ComingSoon from '../ComingSoon';

const Formatter = () => {
    return (
        <ComingSoon 
            title="📝 Formatter"
            description="XML und JSON Code-Formatierung leicht gemacht"
            icon="🛠️"
            features={[
                "XML formatieren und validieren",
                "JSON formatieren und beautify",
                "XML zu JSON konvertieren",
                "JSON zu XML konvertieren",
                "Minify & Komprimieren",
                "Syntax-Highlighting"
            ]}
        />
    );
};

export default Formatter;